<template>
    <form class="rf-view login-view" @submit.prevent="submit">
        <NavigationBar :title="$t('buttons.login')">
            <BackButton v-if="canPop" slot="left" @click="pop" />
        </NavigationBar>
        <main>
            <h1>
                {{ $t('buttons.login') }}
            </h1>

            <GeneralErrorsView :error-box="errorBox" />

            <InputBox :title="$t('fields.email')" :error-box="errorBox" error-fields="email">
                <input v-model="email" class="input" :placeholder="String($t('fields.placeholders.email'))"
                    autocomplete="username" type="email">
            </InputBox>

            <InputBox :title="$t('fields.password')" :error-box="errorBox" error-fields="password">
                <input v-model="password" class="input" :placeholder="String($t('fields.placeholders.password'))"
                    autocomplete="current-password" type="password">
            </InputBox>
        </main>

        <FloatingFooter class="noSticky">
            <LoadingButton :loading="loading" class="block">
                <button class="button primary full">
                    {{ $t('buttons.login') }}
                </button>
            </LoadingButton>
            <button class="button secundary full" type="button" @click="forgot">
                {{ $t('buttons.forgotPassword') }}
            </button>
        </FloatingFooter>
    </form>
</template>


<script lang="ts">
import { BackButton,FloatingFooter, ForgotPasswordView, InputBox, LoadingButton, NavigationBar } from "@restofrit/components"
import { NetworkManager, Session } from "@restofrit/networking";
import { PasswordGrantStruct, Token } from "@restofrit/structures";
import { ErrorBox, GeneralErrorsView } from "@simonbackx/simple-error-forms";
import { ComponentWithProperties, HistoryManager, NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins } from "vue-property-decorator";

@Component({
    components: {
        InputBox,
        GeneralErrorsView,
        LoadingButton,
        FloatingFooter,
        NavigationBar,
        BackButton
    },
})
export default class LoginView extends Mixins(NavigationMixin) {
    errorBox: ErrorBox | null = null
    email = ""
    password = ""
    loading = false

    mounted() {
        HistoryManager.setUrl("/login");
    }

    async submit() {
        if (this.loading) {
            return
        }
        this.loading = true
        this.errorBox = null

        try {
            const response = await NetworkManager.server.request({
                method: "POST",
                path: "/auth/token",
                body: new PasswordGrantStruct({
                    username: this.email,
                    password: this.password
                }),
                decoder: Token
            })
            await Session.shared.setToken(response.data)
        } catch (e) {
            this.errorBox = new ErrorBox(e)
        }
        this.loading = false
    }

    forgot() {
        // side-view, not sheet/popup: vue-app-navigation 1.28 only styles the
        // -old variants of those, so on screens over 700-800px a sheet/popup
        // renders unpositioned below the page. Narrower screens (the native app)
        // get the same full-screen view for every style. Same as the dashboard.
        this.present(new ComponentWithProperties(ForgotPasswordView).setDisplayStyle("side-view"))
    }
    
}
</script>